<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id"/>
		<div class="p-x-16 p-d-16" :id="id" v-show="!diterapkan">
			<div class="m-d-16" v-if="optionData.length > 0">
				<SOInputSelect
					:title="'Berdasarkan'"
					:options="optionData"
					:selected="optionSelected"
					@option-selected="applySelectedOption"
				/>
			</div>

			<label class="form-label require">
				Jenis Periode
			</label>
			<SOInputRadioBig
				:radio-group="periode"
				:radio-selected="filterItem.periode.filterBy"
				@selected-radio="seletedPeriode"
			/>

			<div v-if="filterItem.periode.filterBy === 'periode'">
				<hr>
				<div class="m-d-16">
					<SOInputDate
						:title="'Tanggal Awal'"
						:id="'start-date'"
						:placeholder="'Tanggal Awal'"
						:value="filterItem.periode.startDate === '' ? $moment().format('YYYY-MM-DD') : filterItem.periode.startDate"
						:max-date="getMinDate()"
						@get-date="selectedStartDate"
					/>
				</div>
				<SOInputDate
					:title="'Tanggal Akhir'"
					:id="'end-date'"
					:placeholder="'Tanggal Akhir'"
					:value="filterItem.periode.endDate === '' ? $moment().format('YYYY-MM-DD') : filterItem.periode.endDate"
					:min-date="filterItem.periode.startDate === '' ? '' : filterItem.periode.startDate"
					:max-date="getMaxDate()"
					@get-date="selectedEndDate"
				/>
			</div>

			<div v-if="filterItem.periode.filterBy === 'bulan'">
				<hr>
				<SOInputMonth
					:title="'Bulan'"
					:id="'month'"
					:placeholder="'Bulan'"
					:max-date="$moment().add(1, 'months').format('YYYY-MM')"
					:value="filterItem.periode.month === '' ? $moment().format('YYYY-MM') : filterItem.periode.month"
					@get-date="selectedMonth"
				/>
			</div>

			<div v-if="filterItem.periode.filterBy === 'tahun'">
				<hr>
				<SOInputSelect
					:title="'Tahun'"
					:options="years"
					:selected="filterItem.periode.year === '' ? $moment().format('YYYY') : filterItem.periode.year"
					@option-selected="selectedYear"
				/>
			</div>

			<div v-if="keterangan !== ''" class="f-regular f-12 f-c-midgrey m-t-16">
				{{ keterangan }}
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOInputDate from "@/so-components/global/input/SOInputDate";
import SOInputMonth from "@/so-components/global/input/SOInputMonth";
import SOInputSelect from "@/so-components/global/input/SOInputSelect.vue";

const years = () => {
	let yearsArr = [];

	let thisYear = parseInt(new Date().getFullYear())
	let startYear = 2017
	let gap = thisYear - startYear
	for (let i = 0; i <= gap; i++) {
		yearsArr = [
			...yearsArr,
			{
				id: (startYear + i).toString(),
				text: (startYear + i).toString(),
			}
		]
	}

	return yearsArr
}

export default {
	name: "SOFilterPeriode",
	components: {
		SOFilterTitle,
		SOInputRadioBig,
		SOInputDate,
		SOInputMonth,
		SOInputSelect,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
		}),
		optionSelected() {
			return this.value;
		}
	},
	props: {
		id: String,
		title: {
			type: String,
			default: "Periode"
		},
		optionData: {
			type: Array,
			default: () => [],
		},
		value: {
			type: String,
			default: ""
		},
		filterGlobalKey: {
			type: String,
			default: ""
		},
		keterangan: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			periode: [
				{
					title: "Tahun",
					name: "periode",
					value: "tahun",
					id: "periode-tahun",
				},
				{
					title: "Bulan",
					name: "periode",
					value: "bulan",
					id: "periode-bulan",
				},
				{
					title: "Tanggal",
					name: "periode",
					value: "periode",
					id: "periode-tanggal",
				},
			],
			years: years(),
			checkedPeriodeId: "",
			diterapkan: false,
		}
	},
	watch: {
		filterItem: {
			handler: function () {
				if (this.filterItem.filterKolomTransaksi === undefined) {
					if (this.filterItem.periode.filterBy === "") {
						this.diterapkan = false;
						$("#periode-tanggal").prop("checked", false)
						$("#periode-bulan").prop("checked", false)
						$("#periode-tahun").prop("checked", false)
					}
				} else {
					if (this.filterItem.periode.filterBy === "" && this.filterItem.filterKolomTransaksi === "") {
						this.diterapkan = false;
						$("#periode-tanggal").prop("checked", false)
						$("#periode-bulan").prop("checked", false)
						$("#periode-tahun").prop("checked", false)
					}
				}
			},
			deep: true,
		},
		"filterItem.periode.filterBy": function(v) {
			if (!this.filterItem.periode.hasOwnProperty('year')) {
				this.selectedYear(this.$moment().format('YYYY'))
			}
        }
	},
	mounted() {
		if (this.title === "") this.title = "Periode"
		this.setDiterapkan()
	},
	methods: {
		setDiterapkan() {
			if (this.filterItem[this.filterGlobalKey] === undefined) {
				this.diterapkan = this.filterItem.periode.filterBy !== ""
			} else {
				setTimeout(() => {
					this.diterapkan = this.filterItem.periode.filterBy !== "" || this.filterItem[this.filterGlobalKey] !== ""
				}, 50)
			}
		},
		seletedPeriode(val) {
			let temp = this.filterItem
			if ($('input[name=periode]:checked').length > 0) {
				if (this.checkedPeriodeId !== $($('input[name=periode]:checked')[0]).attr("id")) {
					this.checkedPeriodeId = $($('input[name=periode]:checked')[0]).attr("id")

					switch (val) {
						case "periode":
							if (temp.periode.startDate === "") temp.periode.startDate = this.$moment().format('YYYY-MM-DD')
							if (temp.periode.endDate === "") temp.periode.endDate = this.$moment().format('YYYY-MM-DD')
							break;
						case "bulan":
							if (temp.periode.month === "") temp.periode.month = this.$moment().format("YYYY-MM")
							break;
						case "tahun":
							if (temp.periode.year === "") temp.periode.year = this.$moment().format("YYYY")
							break;
					}

					temp.periode.filterBy = val
					this.$store.commit("filterGlobalModule/setFilterItem", temp)
					this.setDiterapkan()

					return;
				}
			}

			$("#" + this.checkedPeriodeId).prop("checked", false)
			this.checkedPeriodeId = ""

			temp.periode.filterBy = ""
			temp.periode.startDate = ""
			temp.periode.endDate = ""
			temp.periode.month = ""
			temp.periode.year = ""
			temp[this.filterGlobalKey] = ""
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.setDiterapkan()
		},
		selectedStartDate(val) {
			let temp = this.filterItem
			temp.periode.startDate = val
			temp.periode.endDate = $("#end-date").val()
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		selectedEndDate(val) {
			let temp = this.filterItem
			temp.periode.startDate = $("#start-date").val()
			temp.periode.endDate = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		selectedMonth(val) {
			let temp = this.filterItem
			temp.periode.month = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		selectedYear(val) {
			let temp = this.filterItem
			temp.periode.year = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		applySelectedOption(val) {
			let temp = this.filterItem
			temp[this.filterGlobalKey] = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)

			this.getMaxDate()
			this.setDiterapkan()
			this.$emit("input", val)
		},

		// custom
		getMinDate() {
			if (this.filterItem.filterKolomTransaksi === "harus_selesai") {
				return ""
			} else {
				return this.filterItem.periode.endDate === "" ? "" : this.filterItem.periode.endDate
			}
		},
		getMaxDate() {
			if (this.filterItem.filterKolomTransaksi === "harus_selesai") {
				return ""
			} else {
				return this.$moment().format('YYYY-MM-DD')
			}
		}
	}
}
</script>